import E from "../constants/config.js";
import { CurrencyTokenType as C } from "../../currency-lib/constants/currency.js";
import { ERROR_CODE as A } from "../../temp-lib/constants/error.js";
import { useMemo as p, useCallback as N } from "react";
import { useTranslation as l } from "react-i18next";
const c = () => {
  const {
    t: e
  } = l(), r = p(() => ({
    [C.Weth]: {
      allowance: E.CURRENCY.WETH.GET_USER_ALLOWANCE,
      request: E.CURRENCY.WETH.REQUEST_ALLOWANCE,
      price: null,
      primevalPrice: null,
      balance: E.CURRENCY.WETH.GET_USER_BALANCE,
      approveErrorCode: -1,
      approveFailMsg: ""
    },
    [C.Usdc]: {
      allowance: E.CURRENCY.USDC.GET_USER_ALLOWANCE,
      request: E.CURRENCY.USDC.REQUEST_ALLOWANCE,
      price: null,
      primevalPrice: null,
      balance: E.CURRENCY.USDC.GET_USER_BALANCE,
      approveErrorCode: -1,
      approveFailMsg: ""
    },
    [C.Anima]: {
      allowance: E.CURRENCY.ANIMA.GET_USER_ALLOWANCE,
      request: E.CURRENCY.ANIMA.REQUEST_ALLOWANCE,
      price: E.CURRENCY.ANIMA.GET_PLANET_PRICE,
      primevalPrice: E.CURRENCY.ANIMA.GET_PLANET_PRICE_FOR_PRIMEVAL,
      balance: E.CURRENCY.ANIMA.GET_USER_BALANCE,
      approveErrorCode: A.CONJUNCT.CANNOT_APPROVE_ANIMA,
      approveFailMsg: e("conjunction.error.approve_anima_failed")
    },
    [C.Aprs]: {
      allowance: E.CURRENCY.APRS.GET_USER_ALLOWANCE,
      request: E.CURRENCY.APRS.REQUEST_ALLOWANCE,
      price: E.CURRENCY.APRS.GET_PLANET_PRICE,
      primevalPrice: E.CURRENCY.APRS.GET_PLANET_PRICE_FOR_PRIMEVAL,
      balance: E.CURRENCY.APRS.GET_USER_BALANCE,
      approveErrorCode: A.CONJUNCT.CANNOT_APPROVE_APRS,
      approveFailMsg: e("conjunction.error.approve_aprs_failed")
    },
    [C.BlackHole]: {
      allowance: E.CONJUNCT.BLACK_HOLE.GET_USER_ALLOWANCE,
      request: E.CONJUNCT.BLACK_HOLE.REQUEST_ALLOWANCE,
      price: E.CONJUNCT.BLACK_HOLE.GET_PLANET_PRICE,
      primevalPrice: E.CONJUNCT.BLACK_HOLE.GET_PLANET_PRICE_FOR_PRIMEVAL,
      balance: E.CONJUNCT.BLACK_HOLE.GET_USER_BALANCE,
      approveErrorCode: A.CONJUNCT.CANNOT_APPROVE_BLACK_HOLE,
      approveFailMsg: e("conjunction.error.approve_black_hole_failed")
    },
    [C.AprsRon]: {
      allowance: E.CURRENCY.APRS_WRON.GET_USER_ALLOWANCE,
      request: E.CURRENCY.APRS_WRON.REQUEST_ALLOWANCE,
      price: null,
      primevalPrice: null,
      balance: E.CURRENCY.APRS_WRON.GET_USER_BALANCE,
      approveErrorCode: -1,
      approveFailMsg: ""
    },
    [C.AnimaRon]: {
      allowance: E.CURRENCY.ANIMA_WRON.GET_USER_ALLOWANCE,
      request: E.CURRENCY.ANIMA_WRON.REQUEST_ALLOWANCE,
      price: null,
      primevalPrice: null,
      balance: E.CURRENCY.ANIMA_WRON.GET_USER_BALANCE,
      approveErrorCode: -1,
      approveFailMsg: ""
    }
  }), [e]), a = N((R, _) => r[R][_], [r]), o = N((R) => ({
    approveErrorCode: r[R].approveErrorCode,
    approveFailMsg: r[R].approveFailMsg
  }), [r]);
  return {
    getContractMap: a,
    getErrorInfo: o
  };
};
export {
  c as default
};
//# sourceMappingURL=useCurrencyContractMapper.js.map
